<template>
  <div
    class="opple-device-card_control"
    :class="{disabled: controlData.disabled}"
  >
    <div>
      <div class="opple-device-card_control_main_info mac">
        <div class="opple-device-card_control_main_label">
          MAC：
        </div>
        <div class="opple-device-card_control_main_value">
          {{ controlData.Mac }}
        </div>
      </div>
      <div class="opple-device-card_control_main">
        <div class="opple-device-card_control_main_info">
          <div class="opple-device-card_control_main_label">
            {{ $t("devicecard.area") }}：
          </div>
          <div class="opple-device-card_control_main_value">
            {{ controlData.ParentAreaNames }}
          </div>
        </div>
        <distinguish
          class="opple-device-card_control_main_btn"
          :msg="data"
          @socket-handler="handlerWsData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Distinguish from "@/components/button/Distinguish";
import {getdeviceImageStatus } from '@/utils/utils'
export default {
  name: 'DeviceCardControl',
  components: {
    Distinguish
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      controlData: {

      }
    };
  },

  computed: {

  },

  watch: {
    data() {
      this.init();
    }
  },

  mounted() {
    this.init();
  },

  methods: {
  getdeviceImageStatus,
   init() {
    const { data } = this;
    const status = this.getdeviceImageStatus(data, '0X0100', '0');

    const controlData = {
      disabled: status,
      ParentAreaNames: data.ParentAreaNames,
      Mac: window.formateMac(data.Mac),
      // bgColor: status ? '#ebeff6' : '#fff'
    }

    this.controlData = controlData;
   },

  //  getdeviceImageStatus(msg, type, value) {
  //     var result = null;
  //     const StatusInfo = msg.StatusInfo;

  //     if (msg != null && StatusInfo != null) {
  //       StatusInfo.forEach((model) => {
  //         if (
  //           model.IsTop &&
  //           model.StatusType.toUpperCase().indexOf(type.toUpperCase()) >= 0 &&
  //           (msg.ChildId != 65535 ? model.ChannelId == msg.ChildId : true) &&
  //           (msg.ChildId == 65535
  //             ? msg.ClassSku.toUpperCase() != "0X001C3003"
  //             : true)&& msg.ChildCategoryType !== 4
  //         ) {
  //           if (model["Value"] == value || model["Value1"] == value) {
  //             result = true;
  //           } else {
  //             result = false;
  //           }
  //         }
  //       });
  //     }
  //     return result;
  //  },

   flash() {
    this.$emit('flash', true);

    setTimeout(() => {
      this.$emit('flash', false);
    }, 2000);
   },

  /* socket推送处理方法
    * rs：推送过来的原始数据包
    */
    handlerWsData(rs) {
      if (rs.StatusCode !== this.$store.state.rightStatusCode) return;
      const { data } = this;
      const { Type, DeviceMac, Id, ChannelId, SyncInfo, ClassSku, DeviceId, VDeviceId, StatusInfo } = rs.Result[0];

      // 识别后闪烁3s
      if (Type === 3 && data.Mac === DeviceMac) {
        this.flash();
      }

      // 修改名称
      if (Type === 15 && data.VDeviceId === Id && data.ChildId === ChannelId) {
          const newData = {
            ...data,
          }

          if (data.ChildId == 65535) {
            newData.DeviceName = SyncInfo;
          } else {
            newData.ChildName = SyncInfo;
          }

          this.$emit('update', newData)
      }

      if (Type == 11) {
        // 状态识别的classsku
        const stateClassSku = ['0x0200031C','0x0200031B','0x0200030C','0x02000301'];

        if (data.DeviceId === DeviceId && stateClassSku.includes(ClassSku)) {
          this.flash();
        }

        if (data.VDeviceId === VDeviceId) {
          const dataStatusInfo = data.StatusInfo || [];
          // 交集
          const intersectionData = (dataStatusInfo || [])
            .filter(item => StatusInfo.some(info =>
              item.name === info.name && item.age === info.age
            ))

          intersectionData.forEach(item => {
          })

          // StatusInfo.forEach((n) => {
          //     if (data.StatusInfo) {
          //       data.StatusInfo.forEach((m) => {
          //         if (
          //           m.StatusType == n.StatusType &&
          //           m.ChannelId == n.ChannelId
          //         ) {
          //           m.Value = n.Value;
          //           if (
          //             m.StatusType == "0x1600" ||
          //             m.StatusType == "0x1601"
          //           ) {
          //             m["ParaUnit"] = "s";
          //           }
          //         }
          //         if (m.StatusCode == "0x0100") {
          //           h.IsOnline = n.Value == "1";
          //         }
          //       });
          //     }
          //   });
        }
      }

    //   } else if (rs.Result[0].Type == 11) {
    //     const stateClassSku = ['0x0200031C'] //状态识别的classsku
    //     this.carddata.forEach((h) => {

    //       if (h.VDeviceId == rs.Result[0].VDeviceId) {
    //         rs.Result[0].StatusInfo.forEach((n) => {
    //           if (h.StatusInfo) {
    //             h.StatusInfo.forEach((m) => {
    //               // if (m.StatusCode == n.StatusCode) {
    //               // 	m.Value = n.Value;
    //               // }
    //               // if (m.StatusCode == '0x0000') {
    //               // 	h.IsOnline = n.Value == '0x0000' ? true : false;
    //               // }
    //               if (
    //                 m.StatusType == n.StatusType &&
    //                 m.ChannelId == n.ChannelId
    //               ) {
    //                 m.Value = n.Value;
    //                 if (
    //                   m.StatusType == "0x1600" ||
    //                   m.StatusType == "0x1601"
    //                 ) {
    //                   m["ParaUnit"] = "s";
    //                 }
    //               }
    //               if (m.StatusCode == "0x0100") {
    //                 h.IsOnline = n.Value == "1";
    //               }
    //             });
    //           }
    //         });

    //         this.formatedevicestatus(h);
    //         // this.$forceUpdate();//强制渲染

    //         // this.getDeviceStateUrl(h.StatusInfo, h, icon_type03);
    //         // this.getDeviceStateTitle(h.StatusInfo, h);
    //       }
    //     });
    //   } else if (rs.Result[0].Type == 10) {
    //     //在线状态
    //     this.carddata.forEach((n) => {
    //       if (n.VDeviceId == rs.Result[0].VDeviceId) {
    //         n.IsOnline = rs.Result[0].IsOnline;
    //       }
    //     });
    //   } else if (rs.Result[0].Type == 13) {
    //     //移动状态（同步中）

    //     this.carddata.forEach((n) => {
    //       if (n.VDeviceId == rs.Result[0].VDeviceId) {
    //         n.InAreaResultCode = rs.Result[0].InAreaResultCode;
    //       }
    //     });
    //   }
    // }
    },
  },
};
</script>

<style lang="scss">
.opple-device-card_control {
  position: absolute;
  box-sizing: border-box;
  width: 100%;
  bottom: 0;
  left: 0;
  line-height: 18px;
  // padding: 17px 20px 0;
  background-color: #fff;

  &.disabled {
    background-color: rgb(235, 239, 246);

    // .opple-device-card_control_main {
    //   opacity: 0.6;
    // }
  }

  &:hover {
    .opple-device-card_control_main_info.mac {
      // visibility: visible;
      display: flex;
      justify-self: flex-start;
    }
  }

  &_main {
    &_info {
      font-size: 12px;
      display: flex;
      width: 80%;
      margin-left: 10%;
      padding-top: 6px;

      &.mac {
        display: none;
        width: 100%;
        box-sizing: border-box;
      }
    }

    &_label {
      width: 54px;
      color: #a8a8a8;
    }

    &_value {
      max-width: 126px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #373737;
    }

    &_btn {
      margin-top: 6px;
      padding: 9px 15px;
      border-radius: 3px;
      color: #606266;
      // border: 1px solid #dcdfe6;
      text-align: center;
      cursor: pointer;

      button {
        width: 100%;
      }
    }
  }
}
</style>